function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

 function resetConsent() {
    const cookieName = "cookieconsent_status";

    // Delete cookie (including with/without domain as fallback)
    document.cookie = cookieName + "=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
    document.cookie = cookieName + "=; path=/; domain=" + window.location.hostname + "; expires=Thu, 01 Jan 1970 00:00:00 GMT";

    // Reload page to retrigger consent banner
    window.location.reload();
  }

/* custom slider */

class SliderContainer{
  constructor(
    sliderContainerElement
  )
  {
    this.sliderContainerElement = sliderContainerElement;
    this.sliderType = "default";
    if(this.sliderContainerElement.classList.contains("js-product-gallery")){
      this.sliderType = "product-gallery";
    }else if(this.sliderContainerElement.classList.contains("js-product-gallery-modal")){
      this.sliderType = "product-gallery-modal";
    }
    this.syncedSliderContainer;
    this.sliderElements = sliderContainerElement.querySelectorAll(".js-slider-items-container");
    this.thumbnails = sliderContainerElement.querySelectorAll(".js-media-thumbnail");
    this.bulletpoints = sliderContainerElement.querySelectorAll(".swiper-pagination-bullet");
    this.productPageMainSlider = document.querySelector("div.product-page-main-slider .js-slider-items-container")
    this.modalMainSlider = sliderContainerElement.querySelector("div.modal-image-gallery-content .js-slider-items-container");
    this.lastActiveBulletpoint;
    this.lastActiveThumbnail;
    this.sliders = [];
    this.mainSliders;

    //zoom variables (only needed for modal)
    this.scale = 1;
    this.pointX = 0;
    this.pointY = 0;
    this.zoomImages;
    this.startX;
    this.startY;
  }

  init(){
    if(this.bulletpoints){
      this.lastActiveBulletpoint = this.bulletpoints[0]
    }
    if(this.thumbnails){
      this.lastActiveThumbnail = this.thumbnails[0];
    }
    this.initSliders();
    this.initThumbnails();
    this.initBulletpoints();
    this.LimitBulletpoints();
    this.setActiveClass(this.lastActiveBulletpoint, "bulletpoint");
    this.setActiveClass(this.lastActiveThumbnail, "thumbnail");

    window.addEventListener('resize', () => {
      this.LimitBulletpoints();
    })
  }

  initSliders(){
    // get slider elements inside of sliderContainer
    var sliderElements = this.sliderContainerElement.querySelectorAll(".js-slider-items-container");
    sliderElements.forEach((sliderElement, index) => {
      // create sliders for every sliderElement
      var slider = new Slider(this, this.sliderContainerElement, sliderElement, 
        this.sliderContainerElement.querySelectorAll(".js-slider-button-prev")[index], 
        this.sliderContainerElement.querySelectorAll(".js-slider-button-next")[index]);
      // call init method of created slider
      slider.init();
      this.sliders.push(slider);
    });
    this.mainSliders = this.sliders.filter(slider => {
      return slider.type === 'main';
    });
  }

  initThumbnails(){
    this.thumbnails.forEach(thumbnail => {
      // add click event for every thumbnail image
      thumbnail.addEventListener('click', () => {
        // get slideIndex from data-attribute of the clicked thumbnail
        const slideIndex = parseInt(thumbnail.getAttribute('data-slide-index'));
          this.mainSliders.forEach((slider) => {
            slider.slideToIndex(slideIndex);
          })
          if(this.syncedSliderContainer){
            this.syncedSliderContainer.mainSliders.forEach((slider) => {
              slider.slideToIndex(slideIndex);
            })
          }
        // set active thumbnail to clicked thumbnail
        this.changeActiveThumbnail(this.lastActiveThumbnail, thumbnail);
        if(this.syncedSliderContainer){
          this.syncedSliderContainer.changeActiveThumbnail(this.syncedSliderContainer.lastActiveThumbnail, 
            this.syncedSliderContainer.thumbnails[slideIndex]);
        }
      });
    });
  }

  initBulletpoints(){
    this.bulletpoints.forEach(bulletpoint =>{
      // add click event for every bulletpoint
      bulletpoint.addEventListener('click', () => {
        // get slideIndex from data-attribute of the clicked bulletpoint
        const slideIndex = parseInt(bulletpoint.getAttribute('data-slide-index'));
        this.mainSliders.forEach((slider) => {
          slider.slideToIndex(slideIndex);
        })
        if(this.syncedSliderContainer){
          this.syncedSliderContainer.mainSliders.forEach((slider) => {
            slider.slideToIndex(slideIndex);
          })
        }
        // set active bulletpoint to clicked bulletpoint
        this.changeActiveBulletPoint(this.lastActiveBulletpoint, bulletpoint);
        if(this.syncedSliderContainer){
          this.syncedSliderContainer.changeActiveBulletPoint(this.syncedSliderContainer.lastActiveBulletpoint, 
            this.syncedSliderContainer.bulletpoints[slideIndex])
        }
      });
    });
  }

  LimitBulletpoints(){
    var mainSlider = this.mainSliders[0];
    var maxBulletpoints = mainSlider.maxIndex;
    var index = 0;
    this.bulletpoints.forEach((bulletpoint) => {
      if(index <= maxBulletpoints){
        bulletpoint.style.display = "";
      }else{
        bulletpoint.style.display = "none";
      }
      index++;
    })
  }

  
  setActiveClass(element, elementType){
    if(element !== undefined){
      switch(elementType){
        case 'bulletpoint':
          element.classList.add("swiper-pagination-bullet-active");
          break;
        case 'thumbnail': 
          element.classList.add("active-thumbnail")
          break;
      }
      
    }
  }

  removeActiveClass(element, elementType){
    if(element !== undefined){
      switch(elementType){
        case 'bulletpoint':
          element.classList.remove("swiper-pagination-bullet-active");
          break;
        case 'thumbnail':
          element.classList.remove("active-thumbnail")
          break;
      }
    
    }
  }

  changeActiveBulletPoint(lastBulletPoint, bulletpoint){
    if(bulletpoint == null){
      return;
    }
    var elementType = 'bulletpoint';
    this.removeActiveClass(lastBulletPoint, elementType);
    this.setActiveClass(bulletpoint, elementType);
    this.lastActiveBulletpoint = bulletpoint;
  }

  changeActiveThumbnail(lastThumbnail, thumbnail){
    if(thumbnail == null){
      return;
    }
    var elementType = 'thumbnail';
    this.removeActiveClass(lastThumbnail, elementType);
    this.setActiveClass(thumbnail, elementType);
    this.lastActiveThumbnail = thumbnail;
    const slideIndex = parseInt(thumbnail.getAttribute('data-slide-index'));
    this.sliders.forEach((slider) => {
      if(slider.type != elementType) return;
      slider.slideToIndex(slideIndex);
    })
  }

  initSync(){
    if(this.syncedSliderContainer){
      this.sliders.forEach((slider) => {
        if(slider.type == "thumbnail"){
          return;
        }
        slider.sliderElement.addEventListener('scroll', () => {
          const currentIndex = slider.sliderElement.getAttribute("data-index");
          this.syncedSliderContainer.changeActiveBulletPoint(this.syncedSliderContainer.lastActiveBulletpoint, 
              this.syncedSliderContainer.bulletpoints[currentIndex]
            )
          this.syncedSliderContainer.changeActiveThumbnail(this.syncedSliderContainer.lastActiveThumbnail, 
              this.syncedSliderContainer.thumbnails[currentIndex]
            )
        })
      })
      if(this.sliderType == "product-gallery-modal"){
        this.initModalZoom();
      }
    }
  }

  resetModalZoom(){
    if(!this.syncedSliderContainer) return;
    this.scale = 1;
    this.pointX = 0;
    this.pointY = 0;
    this.zoomImages.forEach(img => {
      img.style.transform = "translate(" + this.pointX + "px, " + this.pointY + "px) scale(" + this.scale + ")";
    });
  }

  initModalZoom(){
    if(!this.syncedSliderContainer){
      return;
    }
    /* custom image-gallery */
    let syncedMainSliderIndex = 0;
    let i = 0;
    this.syncedSliderContainer.sliders.forEach((slider) => {
      if(slider.type == "main"){
        syncedMainSliderIndex = i;
      }else{
        i++;
      }
    });
    let mainContent = document.getElementById("MainContent");
    let modalImageGalleryContainer = document.querySelector(".js-modal-image-gallery-container");
    let modalImageGallerySiteOverlay = modalImageGalleryContainer.querySelector(".js-modal-image-gallery-site-overlay");
    let syncedSliderImages = this.syncedSliderContainer.sliders[syncedMainSliderIndex].sliderElement.querySelectorAll(".js-custom__slide_item");
    let closeImageGalleryButton = modalImageGalleryContainer.querySelector(".js-close-image-gallery");
    
    syncedSliderImages.forEach(syncedSliderImage => {
      let isDragging = false;
    
      syncedSliderImage.addEventListener('mousedown', (event) => {
        // Speichert die Startposition der Maus, wenn die Maustaste gedrückt wird
        this.startX = event.clientX;
        this.startY = event.clientY;
        isDragging = false; // Zurücksetzen des Dragging-Status
      });
    
      syncedSliderImage.addEventListener('mousemove', (event) => {
        if (this.syncedSliderContainer.sliders[syncedMainSliderIndex].isDragging) {
          isDragging = true;
        }
      });
    
      syncedSliderImage.addEventListener('mouseup', () => {
        // Das Event wird nur ausgelöst, wenn es kein Drag war
          if (!isDragging) {
            this.syncedSliderContainer.sliders.forEach((slider) => {
              slider.isDragging = false;
              slider.mouseDown = false;
            })
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            document.body.classList.add('no-scroll');
            modalImageGalleryContainer.classList.add("active");
            modalImageGalleryContainer.focus();
            mainContent.style.zIndex = 20;
            syncedSliderImage.scrollTo({ top: 0, left: 4000, behavior: "smooth" });
            this.sliders.forEach((slider) => {
              slider.handleSlideItemSize(slider.sliderElement, slider.gap); 
              slider.handleArrows();
              slider.calculateMaxIndex();
              slider.slideToIndex(syncedSliderImage.dataset.index, "instant");
            })
          }
      });
    });

    window.addEventListener('keydown', (event) => {
      if(event.key == "Escape"){
        CloseImageGallery();
      }
    })
  
    modalImageGallerySiteOverlay.addEventListener('click', () => {
        CloseImageGallery();
    })
    
    closeImageGalleryButton.addEventListener('click', () => {
        CloseImageGallery();
    })
    
    const CloseImageGallery = () => {
        modalImageGalleryContainer.classList.remove("active");
        document.body.classList.remove('no-scroll');
        mainContent.style.zIndex = "";
        this.resetModalZoom();
    }
    
    /* lens functionality */
    
    var panning = false;
    var start = { x: 0, y: 0 };
    this.zoomImages = modalImageGalleryContainer.querySelectorAll(".zoom-image");
    var maxScale = 3; // Maximale Zoom-Stufe
    /*
    this.zoomImages.forEach((zoom) => {

      this.limitPan(zoom);

      const onStart = (e) => {
        e.preventDefault();
        panning = true;
      
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      
        start = { x: clientX - this.pointX, y: clientY - this.pointY };
      };

      let isTouchUpdating = false;
      let lastTouchDistance = null;
      
      const onMove = (e) => {
        if (!panning) return;
      
        e.preventDefault();
      
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      
        this.pointX = clientX - start.x;
        this.pointY = clientY - start.y;
      
        if (!isTouchUpdating) {
          isTouchUpdating = true;
          requestAnimationFrame(() => {
            this.limitPan(zoom);
            zoom.style.transform =
              `translate(${this.pointX}px, ${this.pointY}px) scale(${this.scale})`;
            isTouchUpdating = false;
          });
        }
      };
      
      const onEnd = (e) => {
        panning = false;
      };
      
      zoom.addEventListener("mousedown", onStart);
      document.addEventListener("mousemove", onMove);
      document.addEventListener("mouseup", onEnd);
      
      zoom.addEventListener("touchstart", onStart, { passive: false });
      document.addEventListener("touchmove", onMove, { passive: false });
      document.addEventListener("touchend", onEnd);

      zoom.addEventListener("wheel", (e) => {
        e.preventDefault();
        var xs = (e.clientX - this.pointX) / this.scale,
            ys = (e.clientY - this.pointY) / this.scale,
            delta = (e.wheelDelta ? e.wheelDelta : -e.deltaY);

        var zoomFactor = 1.2;

        if(Math.abs(e.deltaY) < 20){
          zoomFactor = 1.04;
        }

        if (delta > 0) {
          this.scale *= zoomFactor;
        } else {
          this.scale /= zoomFactor;
        }

        this.scale = Math.min(this.scale, maxScale);
        this.scale = Math.max(this.scale, 1);

        this.pointX = e.clientX - xs * this.scale;
        this.pointY = e.clientY - ys * this.scale;

        this.limitPan(zoom);
        zoom.style.transform = "translate(" + this.pointX + "px, " + this.pointY + "px) scale(" + this.scale + ")";
      }, { passive: false });

      zoom.addEventListener("touchmove", (e) => {
        if (e.touches.length === 2) {
            e.preventDefault();
            
            let touch1 = e.touches[0];
            let touch2 = e.touches[1];

            let currentDistance = Math.hypot(
                touch2.clientX - touch1.clientX,
                touch2.clientY - touch1.clientY
            );

            if (lastTouchDistance) {
                let zoomFactor = currentDistance / lastTouchDistance;
                this.scale *= zoomFactor;

                this.scale = Math.min(this.scale, maxScale);
                this.scale = Math.max(this.scale, 1);

                zoom.style.transform = `translate(${this.pointX}px, ${this.pointY}px) scale(${this.scale})`;
            }

            lastTouchDistance = currentDistance;
        }
      }, { passive: false });

      zoom.addEventListener("touchend", () => {
        lastTouchDistance = null;
      });
    });
    */
  }
  limitPan(zoom){
    const container = zoom.parentElement; // Der Container des Bildes
    const rect = zoom.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    // Berechne die maximalen Verschiebungen
    const minX = Math.min(0, containerRect.width - rect.width);
    const maxX = Math.max(0, containerRect.width - rect.width);
    const minY = Math.min(0, containerRect.height - rect.height);
    const maxY = Math.max(0, containerRect.height - rect.height);

    // Begrenze pointX und pointY
    this.pointX = Math.max(minX, Math.min(maxX, this.pointX));
    this.pointY = Math.max(minY, Math.min(maxY, this.pointY));
  }

  /* end lens functionality */
  
    /* end custom image-gallery */
}

class Slider{
  constructor(
    sliderContainerObject,
    sliderContainerElement,
    sliderElement,
    prevButton,
    nextButton
  )
  {
    this.sliderContainerObject = sliderContainerObject;
    this.sliderContainerElement = sliderContainerElement;
    this.sliderElement = sliderElement;
    this.prevButton = prevButton;
    this.nextButton = nextButton;
    this.mouseDown;
    this.isDragging;
    this.startPos;
    this.scrollPos;
    this.gap = parseFloat(getComputedStyle(this.sliderElement).gap);
    this.type = this.sliderElement.classList.contains('js-thumbnails')?'thumbnail':'main'
    this.scrollTimeout = null;
    this.isScrolling = false;
    this.maxIndex = this.getVisibleSliderElements(this.sliderElement).length;
  }

  init(){
    // set current index to 0
    this.sliderElement.dataset.index = 0;
    // if button is not null add slide function to buttons
    if(this.prevButton != null){
      this.prevButton.addEventListener('click', () => { 
        this.slide(this.sliderElement, true);
        if(this.sliderContainerObject.syncedSliderContainer){
          this.sliderContainerObject.syncedSliderContainer.sliders.forEach((slider) => {
            if(slider.type != this.type) return;
            slider.slide(slider.sliderElement, true);
          })
        }
      });
      this.nextButton.addEventListener('click', () => { 
        this.slide(this.sliderElement, false);
        if(this.sliderContainerObject.syncedSliderContainer){
          this.sliderContainerObject.syncedSliderContainer.sliders.forEach((slider) => {
            if(slider.type != this.type) return;
            slider.slide(slider.sliderElement, false);
          })
        }
      });
    }
    this.handleSlideItemSize(this.sliderElement, this.gap);
    this.handleArrows();
    this.sliderElement.addEventListener('scroll', () => {
      this.handleArrows();
    })
    // if slider should be draggable add all needed events
    if(this.sliderElement.classList.contains('js-drag')){
  
      // prevent images or links to be draggable (default drag from browser)
      this.sliderElement.querySelectorAll('img, a').forEach((element) => {
        element.addEventListener('dragstart', (e) => e.preventDefault());
      })
      window.addEventListener('touchmove', (e) => {this.move(e)}, false);
      window.addEventListener('pointermove', (e) => {this.move(e)}, false);
      this.sliderElement.addEventListener('touchstart', (e) => {this.startDragging(e)}, false);
      this.sliderElement.addEventListener('mousedown', (e) => {this.startDragging(e)}, false);
      this.sliderElement.addEventListener('wheel', (e) => { this.wheelMove(e) }, { passive: false });
      window.addEventListener('touchend', (e) => {this.stopDragging(e)}, false);
      window.addEventListener('pointerup', (e) => {this.stopDragging(e)}, false);
      window.addEventListener('click', (e) => {
        if(this.isDragging){
          e.preventDefault();
          e.stopPropagation();
        }
        this.isDragging = false;
      }, false);
      this.handleGrab();
      window.addEventListener('resize', () => { 
        this.handleSlideItemSize(this.sliderElement, this.gap); 
        this.handleArrows();
        this.calculateMaxIndex();
       }, false);
    }

    this.calculateMaxIndex();
  }

  calculateMaxIndex(){
    var visibleSliderElements = this.getVisibleSliderElements(this.sliderElement);
    var itemWidth = this.getSliderItemSize(visibleSliderElements, this.sliderElement);
    if(!this.isVertical(this.sliderElement)){
      this.maxIndex = Math.ceil((this.sliderElement.scrollWidth - this.sliderElement.clientWidth) / itemWidth);
    }else{
      this.maxIndex = Math.ceil((this.sliderElement.scrollHeight - this.sliderElement.clientHeight) / itemWidth);
    }
  }

  startDragging(event){
    if(this.isOverflown(this.sliderElement)){
      var pagePos = this.isVertical(this.sliderElement)?event.pageY:event.pageX;
      if(event.type === 'touchstart' && event.touches[0]){
        pagePos = this.isVertical(this.sliderElement)?event.touches[0].pageY:event.touches[0].pageX;
      }
      this.mouseDown = true;
      this.isDragging = false;
      this.startPos = pagePos - (this.isVertical(this.sliderElement)?this.sliderElement.offsetTop:this.sliderElement.offsetLeft);
      this.scrollPos = this.isVertical(this.sliderElement)?this.sliderElement.scrollTop:this.sliderElement.scrollLeft;
    }
  }

  stopDragging(event){
    if(this.sliderContainerObject.sliderType == "product-gallery-modal") return;
    if(this.isDragging){
      if(event.type === 'touchend'){
        this.isDragging = false;
      }else if(event.type === 'wheel'){
        this.isDragging = false;
      }
      this.setDefaultCursor();
      var visibleSliderElements = this.getVisibleSliderElements(this.sliderElement);
      var sliderItemSize = this.getSliderItemSize(visibleSliderElements, this.sliderElement);
      var currentItem = this.roundCalculateCurrentItem(this.sliderElement, sliderItemSize);
      if(this.sliderElement.classList.contains("js-drag-single") && event.type !== 'wheel'){
        currentItem = this.handleSingleMovement(event, sliderItemSize, visibleSliderElements);
      }else if(this.sliderElement.classList.contains("js-drag-align") || event.type === 'wheel'){
        currentItem = this.handleAlignMovement(sliderItemSize, visibleSliderElements);
      }
      if(currentItem >= 0){
        if(currentItem === visibleSliderElements.length){
          currentItem = currentItem - 1;
        }
        this.sliderContainerObject.changeActiveBulletPoint(this.sliderContainerObject.lastActiveBulletpoint, this.sliderContainerObject.bulletpoints[currentItem]);
        if(!this.sliderElement.classList.contains('js-thumbnails')){
          this.sliderContainerObject.changeActiveThumbnail(this.sliderContainerObject.lastActiveThumbnail, this.sliderContainerObject.thumbnails[currentItem]);
        }
      }

    }
    this.mouseDown = false;
  }

  handleSingleMovement(event, sliderItemSize, visibleSliderElements){
    var currentItem = this.getCurrentItem(this.sliderElement, sliderItemSize, false);
    var pagePos = this.isVertical(this.sliderElement)?event.pageY:event.pageX;
    if(event.type === 'touchend' && event.touches[0]){
      pagePos = this.isVertical(this.sliderElement)?event.touches[0].pageY:event.touches[0].pageX;
    }
    
    const x = pagePos - (this.isVertical(this.sliderElement)?this.sliderElement.offsetTop:this.sliderElement.offsetLeft);
    const scroll = x - this.startPos;
    currentItem -= scroll?scroll<0?-1:1:0;
    this.setCurrentItemData(this.sliderElement, visibleSliderElements, currentItem);
    this.sliderElement.scrollTo({ top: (currentItem * sliderItemSize), left: (currentItem * sliderItemSize), behavior: "smooth" });
    if(this.sliderContainerObject.syncedSliderContainer){
      this.sliderContainerObject.syncedSliderContainer.sliders.forEach((slider) => {
        if(slider.type != this.type) return;
        slider.slideToIndex(currentItem);
      })
    }
    return currentItem;
  }

  handleAlignMovement(sliderItemSize, visibleSliderElements){
    if(!this.isAtEnd()){
          var currentItem = this.roundCalculateCurrentItem(this.sliderElement, sliderItemSize);
          this.setCurrentItemData(this.sliderElement, visibleSliderElements, currentItem);
          this.sliderElement.scrollTo({ top: (currentItem * sliderItemSize), left: (currentItem * sliderItemSize), behavior: "smooth" });
          return currentItem;
        }
        return visibleSliderElements.length - 1;
  }

  handleArrows(){
    // set arrow visibility based on slider position
      if(this.isOverflown(this.sliderElement)){
          // if slider is at the start position hide prev arrow
          if(this.isAtBeginning()){
              this.prevButton.style.display = "none";
            }
            else{
              this.prevButton.style.display = "block";
            }
            
            // if slider is at end position hide next button
            if(this.isAtEnd()){
              this.nextButton.style.display = "none";
            }else{
              this.nextButton.style.display = "block";
            }
      }else
      {
        // if slider is completely shown no arrow is needed. So both are hidden
          this.sliderElement.style.justifyContent = null;
          this.prevButton.style.display = "none";
          this.nextButton.style.display = "none";
      }
  }

  isAtBeginning(){
    return this.isVertical(this.sliderElement) ? this.sliderElement.scrollTop == 0 : this.sliderElement.scrollLeft == 0;
  }

  isAtEnd(){
    return this.isVertical(this.sliderElement) ? this.sliderElement.scrollTop >= this.sliderElement.scrollHeight - (this.sliderElement.clientHeight + 10)
    :this.sliderElement.scrollLeft >= this.sliderElement.scrollWidth - (this.sliderElement.clientWidth + 10);
  }

  slide(sliderElement, slideLeft) {
    // slide one element to the left or right
    var visibleSliderElements = this.getVisibleSliderElements(sliderElement);
    var sliderItemSize = this.getSliderItemSize(visibleSliderElements, this.sliderElement);
    var currentItem = 0;
    if(slideLeft){
      // scroll one element to the left
      currentItem = this.getCurrentItem(this.sliderElement, sliderItemSize, true);
      currentItem--;
      this.setCurrentItemData(this.sliderElement, visibleSliderElements, currentItem);
      this.sliderElement.scrollTo({ top: currentItem * sliderItemSize, left: currentItem * sliderItemSize, behavior: "smooth" });
      
    }else{
      // scroll one element to the right
      currentItem = this.getCurrentItem(this.sliderElement, sliderItemSize, false);
      currentItem++;
      this.setCurrentItemData(this.sliderElement, visibleSliderElements, currentItem);
      this.sliderElement.scrollTo({ top: currentItem * sliderItemSize, left: currentItem * sliderItemSize, behavior: "smooth" });
      
    }
    if(currentItem >= 0){
      if(currentItem === visibleSliderElements.length){
        currentItem = currentItem - 1;
      }
      this.sliderContainerObject.changeActiveBulletPoint(this.sliderContainerObject.lastActiveBulletpoint, this.sliderContainerObject.bulletpoints[currentItem]);
      if(!this.sliderElement.classList.contains('js-thumbnails')){
        this.sliderContainerObject.changeActiveThumbnail(this.sliderContainerObject.lastActiveThumbnail, this.sliderContainerObject.thumbnails[currentItem]);
      }
    }
  }

  slideToIndex(index, slideBehavior = "smooth"){
    var sliderItemElements = this.getVisibleSliderElements(this.sliderElement);
    var sliderItemSize = this.getSliderItemSize(sliderItemElements, this.sliderElement);
    
    this.isVertical(this.sliderElement)?
    this.sliderElement.scrollTo({ top: index * sliderItemSize, left: 0, behavior: slideBehavior }):
    this.sliderElement.scrollTo({ top: 0, left: index * sliderItemSize, behavior: slideBehavior });
    this.setCurrentItemData(this.sliderElement, sliderItemElements, index);
  }

  wheelMove(event){
    if(event.deltaX != 0){
      if(!this.isScrolling){
        this.isScrolling = true;
        this.startDragging(event);
      }
      this.move(event);
    }
    if(this.isScrolling){
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.stopDragging(event);
        this.isScrolling = false;
      }, 200);
    }
  }

  move(event) {
    if(this.isOverflown(this.sliderElement)){
      if(!this.mouseDown) { return; }
      if(!this.isDragging && Math.abs((event.pageX - this.sliderElement.offsetLeft) - this.startPos) <= 5){
        return;
      }
      if(!this.isDragging){
        this.setGrabCursor();
      }
      this.isDragging = true;
      if(!this.sliderElement.classList.contains("js-drag-single") || event.type === "wheel"){
        var pagePos = this.isVertical(this.sliderElement)?event.pageY:event.pageX;
        if(event.type === 'touchmove' && event.touches[0]){
          pagePos = this.isVertical(this.sliderElement)?event.touches[0].pageY:event.touches[0].pageX;
        }
        const x = pagePos - (this.isVertical(this.sliderElement)?this.sliderElement.offsetTop:this.sliderElement.offsetLeft);
        const scroll = x - this.startPos;
        if(event.type !== 'wheel'){
          this.sliderElement.scrollTo({ top: this.scrollPos - scroll, left: this.scrollPos - scroll, behavior: "instant" });
        }
        var visibleSliderElements = this.getVisibleSliderElements(this.sliderElement);
        var sliderItemSize = this.getSliderItemSize(visibleSliderElements, this.sliderElement);
        var currentItem = this.roundCalculateCurrentItem(this.sliderElement, sliderItemSize);
        this.sliderElement.dataset.index = currentItem;
        this.sliderContainerObject.changeActiveBulletPoint(this.sliderContainerObject.lastActiveBulletpoint, this.sliderContainerObject.bulletpoints[this.roundCalculateCurrentItem(this.sliderElement, sliderItemSize)]);
        if(!this.sliderElement.classList.contains('js-thumbnails')){
          this.sliderContainerObject.changeActiveThumbnail(this.sliderContainerObject.lastActiveThumbnail, this.sliderContainerObject.thumbnails[currentItem]);
        }
      }
    }
  }

  handleGrab(){
    if(!this.isOverflown(this.sliderElement)){
      this.sliderElement.classList.remove("drag");
    }else{
      this.sliderElement.classList.add("drag");
    }
  }

  setDefaultCursor(){
    this.sliderElement.style.cursor = ""
    this.sliderElement.querySelectorAll("a").forEach((a) => {
      a.style.cursor = "";
    })
  }

  setGrabCursor(){
    this.sliderElement.style.cursor = "grabbing"
    this.sliderElement.querySelectorAll("a").forEach((a) => {
      a.style.cursor = "grabbing";
    })
  }

  isVertical(sliderElement){
    return sliderElement.classList.contains("js-slider-vertical");
  }

  setCurrentItemData(sliderElement, visibleSliderElements, currentItem) {
    if(currentItem > this.maxIndex){
      currentItem = this.maxIndex;
    }else if(currentItem < 0){
      currentItem = 0;
    }
    sliderElement.dataset.index = currentItem;

    if(this.sliderContainerObject.sliderType == "product-gallery-modal"){
      this.sliderContainerObject.resetModalZoom()
    }
  }

  getVisibleSliderElements(sliderElement){
    var visibleSliderElements = sliderElement.querySelectorAll('.js-custom__slide_item');
    return Array.from(visibleSliderElements).filter(element => {
      return getComputedStyle(element).display !== 'none';
    })
  }

  getSliderItemSize(sliderElements, sliderElement){
    var visibleSliderElement = sliderElements[0];
    if(visibleSliderElement == null)return 0;
    // calculate the width of a single slide element
    if(this.isVertical(sliderElement)){
      return visibleSliderElement.scrollHeight + parseFloat(getComputedStyle(sliderElement).gap) +  2 * parseFloat(getComputedStyle(visibleSliderElement).borderWidth);
    }else{
      return visibleSliderElement.scrollWidth + parseFloat(getComputedStyle(sliderElement).gap) +  2 * parseFloat(getComputedStyle(visibleSliderElement).borderWidth);
    }
  }

  getCurrentItem(sliderElement, sliderItemSize, ceil) {
    var currentItem;
    if(sliderElement.getAttribute("data-index") != "undefined"){
      return parseInt(sliderElement.dataset.index);
    }
    currentItem = this.calculateCurrentItem(sliderElement, sliderItemSize, ceil);
    
    return currentItem;
  }

  calculateCurrentItem(sliderElement, sliderItemSize, ceil){
    var currentItem;
    if(ceil){
      currentItem = Math.ceil(this.isVertical(sliderElement)?sliderElement.scrollTop / sliderItemSize
      :sliderElement.scrollLeft / sliderItemSize);
    }else{
      currentItem = Math.floor(this.isVertical(sliderElement)?sliderElement.scrollTop / sliderItemSize
      :sliderElement.scrollLeft / sliderItemSize);
    }
    return currentItem;
  }

  roundCalculateCurrentItem(sliderElement, sliderItemSize){
    return Math.round(this.isVertical(sliderElement)?sliderElement.scrollTop / sliderItemSize
    :sliderElement.scrollLeft / sliderItemSize);
  }

  handleSlideItemSize(sliderElement, gap){
    // sets the slide size based on the available space
      var slideItems = sliderElement.querySelectorAll(".js-custom__slide_item.auto_scale");
      if(slideItems.length <= 0){
          return;
      }
      if(this.isOverflown(sliderElement)){
        sliderElement.style.justifyContent = "unset";
          sliderElement.classList.add("slide");
          slideItems.forEach((slide) => {
            if(this.isVertical(sliderElement)){
              slide.style.minWidth = (slide.children[0].scrollHeight + gap) + "px";
            }else{
              slide.style.minWidth = (slide.children[0].scrollWidth + gap) + "px";
            }
            
          })
          var sliderItemSize;
          var showableItems;
          if(this.isVertical(sliderElement)){
            sliderItemSize = sliderElement.querySelector(".js-custom__slide_item.auto_scale").children[0].scrollHeight + gap
            showableItems = Math.floor(sliderElement.clientHeight / sliderItemSize);
          }else{
            sliderItemSize = sliderElement.querySelector(".js-custom__slide_item.auto_scale").children[0].scrollWidth + gap
            showableItems = Math.floor(sliderElement.clientWidth / sliderItemSize);
          }
           
          if(showableItems == 0) showableItems = 1;

          slideItems.forEach((slide) => {
              slide.style.flex = '0 0 calc(100% / ' + showableItems + ')';
          })
      }else{
        sliderElement.classList.remove("slide");
          slideItems.forEach((slide) => {
              slide.style.flex = null;
              slide.style.minWidth = null;
              slide.style.minHeight = null;
          })
      }
  }

    isOverflown(element){
    // checks if the element is overflowing
      return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
    }

}

(function initSlider(){
    var sliderContainerElements  = document.querySelectorAll(".js-slider");
    var productGallerySlider;
    var productGalleryModalSlider;
    sliderContainerElements.forEach((sliderContainerElement) => {
      var sliderContainer = new SliderContainer(sliderContainerElement);
      sliderContainer.init();
      if(sliderContainer.sliderType == "product-gallery-modal"){
        productGalleryModalSlider = sliderContainer;
      }else if(sliderContainer.sliderType == "product-gallery"){
        productGallerySlider = sliderContainer;
      }
    })
    if(productGallerySlider && productGalleryModalSlider){
      productGallerySlider.syncedSliderContainer = productGalleryModalSlider;
      productGalleryModalSlider.syncedSliderContainer = productGallerySlider;
      productGallerySlider.initSync();
      productGalleryModalSlider.initSync();
    }
    
  })();

 

  /* end custom slider */

  /* custom accordion */

  (function initAccordion() {
    var accElements = document.querySelectorAll('.js-acc-sect');
    accElements.forEach((element) => {
      let sectionTitleElement = element.querySelector('.js-section-title');
      if(sectionTitleElement){
        var contentElement = element.querySelector('.js-section-content');
        if(element.dataset.active == 'false'){
          changeItemState(false, element);
          contentElement.style.height = 0;
        }else{
          changeItemState(true, element);
          contentElement.style.height = contentElement.scrollHeight + 'px';
        }

        sectionTitleElement.addEventListener('click', (event) => {
          onAccItemClicked(event, element)
        });
      }
      window.addEventListener('resize', (event) => {
        disableTransitionOnViewportChange(event, element)
      });
    });
  })();
  
  async function disableTransitionOnViewportChange(event, accElement){
    var contentElement = accElement.querySelector('.js-section-content');
    contentElement.style.transition = "unset";
      setTimeout(() => {
        contentElement.style.transition = ""
      }, 10);
  }

  async function onAccItemClicked(event, element) {
    var contentElement = element.querySelector('.js-section-content');
    var accWidth = element.dataset.accWidth
    if(accWidth && window.innerWidth > accWidth){
      return;
    }
    if (element.dataset.active == 'false') {
      changeItemState(true, element);
      contentElement.style.height = 0;
      openItem(contentElement);
    } else {
      changeItemState(false, element);
      contentElement.style.height = contentElement.scrollHeight + 'px';
      closeItem(contentElement);
    }
    setTimeout(() => {
      AOS.refresh();
    }, 500)
  }
  async function closeItem(contentElement) {
      contentElement.style.height = 0 + "px";
  }

  async function openItem(contentElement) {
      contentElement.style.height = contentElement.scrollHeight + "px";
  }

  function changeItemState(toActive, element) {
    var notActiveIconElement = element.querySelector('.js-acc-header-icon-not-active');
    var activeIconElement = element.querySelector('.js-acc-header-icon-active');
    if(notActiveIconElement) notActiveIconElement.style.display = toActive == true ? 'none' : 'block';
    if(activeIconElement) activeIconElement.style.display = toActive == true ? 'block' : 'none';
    element.dataset.active = toActive == true ? 'true' : 'false';
  }

  /* end custom accordion */

  /* header */

  class Header{

    constructor(){
      this.headerElement = document.querySelector(".js-header-section");
      this.mainContent = document.getElementById("MainContent");
      this.contactBox = document.querySelector(".js-contact-box");
      this.placeholder = document.querySelector(".js-header-placeholder")
      this.logo = document.querySelector(".js-theme__logo");
      this.nav = document.querySelector(".js-nav");
      this.themeHeader = document.querySelector(".js-theme-header");
      this.setNavHeight();
      this.stickyType = this.headerElement != null?this.headerElement.dataset.stickyType:"all";

      this.topBars = [];
      document.querySelectorAll(".js-top-bar").forEach((topBarElement) => {
        this.topBars.push(new TopBar(topBarElement, this));
      })

      this.updateStickyState();
    }

    setNavHeight(){
      this.navHeight = this.nav != null?this.nav.clientHeight:0;
    }

    calculateStickyNavHeight(topDistance, bottomDistance){
      return this.nav != null?this.nav.clientHeight + topDistance + bottomDistance:0 + topDistance + bottomDistance;
    }

    updateStickyState(){
      this.setNavHeight();
      let navMax = 980;
      if(this.headerElement.hasAttribute("data-nav-max")) navMax = this.headerElement.dataset.navMax;
      if(this.stickyType === "nav" && window.innerWidth > navMax){
        this.headerElement.classList.remove("sticky");
        this.headerElement.style.top = "";
        this.updateNavStickyState();
      }else{
        this.headerElement.classList.remove("nav-sticky");
        this.nav.style.top = "";
        this.updateHeaderStickyState();
      }
    }

    updateHeaderStickyState() {
      let amountToScroll = 0;
      this.topBars.forEach((topBar) => {
        if(topBar.isAboveHeader && !topBar.isSticky){
          amountToScroll += topBar.getClientHeight()
        };
      })
      let topDistance = 0;
      let bottomDistance = 0;
      if (window.scrollY > amountToScroll) {
        this.topBars.forEach((topBar) => {
          topBar.updateStickyState(topDistance, true);
          if(topBar.isAboveHeader && topBar.isSticky){
            topDistance += topBar.getClientHeight();
          }else if(!topBar.isAboveHeader && topBar.isSticky){
            bottomDistance += topBar.getClientHeight();
          };
        })
        this.headerElement.style.top = topDistance + "px";
        if(this.contactBox) this.contactBox.style.top = (parseInt(this.headerElement.clientHeight + topDistance + bottomDistance) + 20) + "px";
        if(this.stickyType == "header"){
          this.nav.style.marginTop = "-" + this.navHeight + "px";
          if(this.placeholder){
            this.placeholder.style.transition = "";
            this.placeholder.style.height = this.navHeight + "px";
          }
          if(this.logo) this.logo.classList.add("sticky");
          this.mainContent.style.marginTop = this.themeHeader.clientHeight + topDistance + bottomDistance + "px";
        }else {
          this.mainContent.style.marginTop = this.headerElement.clientHeight + topDistance + bottomDistance + "px";
        }
        this.headerElement.classList.add("sticky");
        this.headerElement.classList.remove("nav-sticky");
      } else {
        this.topBars.forEach((topBar) => {
          topBar.updateStickyState(topDistance, false);
        })
        this.headerElement.style.top = "";
        this.mainContent.style.marginTop = 0;
        if(this.stickyType == "header"){
          if(this.placeholder){
            this.placeholder.style.transition = getComputedStyle(this.nav).transition;
            this.placeholder.style.height = 0;
          } 
          this.nav.style.marginTop = 0;
          if(this.logo) this.logo.classList.remove("sticky");
        }
        this.headerElement.classList.remove("sticky");
        
        if(this.contactBox) this.contactBox.style.top = 0;
      }
    }

    updateNavStickyState(){
      let topBarHeight = 0;
      this.topBars.forEach((topBar) => {
        if(topBar.isAboveHeader && !topBar.isSticky) topBarHeight += topBar.getClientHeight();
      })
      let amountToScroll = topBarHeight + this.themeHeader.clientHeight;
      let topDistance = 0;
      let bottomDistance = 0;
      if(window.pageYOffset > amountToScroll){
        this.topBars.forEach((topBar) => {
          topBar.updateStickyState(topDistance, true);
          if(topBar.isAboveHeader && topBar.isSticky){
            topDistance += topBar.getClientHeight();
          } else if(!topBar.isAboveHeader && topBar.isSticky){
            bottomDistance += topBar.getClientHeight();
          } 
        })
        this.nav.style.top = topDistance + "px";
        this.headerElement.classList.add("nav-sticky");
        this.headerElement.classList.remove("sticky");
        this.mainContent.style.marginTop = this.calculateStickyNavHeight(topDistance, bottomDistance) + "px";
        if(this.contactBox) this.contactBox.style.top = (this.calculateStickyNavHeight(topDistance, bottomDistance) + 20) + "px";
      } else {
        this.topBars.forEach((topBar) => {
          topBar.updateStickyState(topDistance, false);
        })
        this.headerElement.classList.remove("nav-sticky");
        this.mainContent.style.marginTop = "0px";
        if(this.contactBox) this.contactBox.style.top = 0;
      }
    }
  }

  class TopBar{
    constructor(element, header){
      this.element = element;
      this.header = header;
      this.isSticky = element.dataset.isSticky === 'true';
      this.isAboveHeader = element.dataset.isAboveHeader === 'true';
    }

    getClientHeight(){
      return this.element.clientHeight;
    }

    updateStickyState(topDistance, headerIsSticky){
      if(!this.isSticky) return;
      if(!headerIsSticky){
        this.deactivateStickyState();
      }
      else if(this.isAboveHeader){
        this.activateStickyState(topDistance);
      }else{
        switch(this.header.stickyType){
          case "nav": 
          if(window.innerWidth > 980){
            this.activateStickyState(topDistance + this.header.nav.clientHeight);
          }else{
            this.activateStickyState(topDistance + this.header.headerElement.clientHeight);
          }
          break;

          case "header":
            this.activateStickyState(topDistance + this.header.themeHeader.clientHeight);
          break;

          case "all":
            this.activateStickyState(topDistance + this.header.headerElement.clientHeight);
          break;
        }
      }
    }

    activateStickyState(topDistance){
      this.element.parentElement.style.position = "fixed";
      this.element.parentElement.style.zIndex = 1;
      this.element.parentElement.style.top = topDistance + "px";
      this.element.parentElement.style.width = "100%";
    }

    deactivateStickyState(){
      this.element.parentElement.style.position = "";
      this.element.parentElement.style.zIndex = "";
      this.element.parentElement.style.top = "";
      this.element.parentElement.style.width = "";
    }
  }

  (function initHeader(){
    const header = new Header();
    document.addEventListener('scroll', () => { header.updateStickyState(); });
    window.addEventListener('resize', () => { header.updateStickyState() });
  })();

  /* end header */

  /* copy Box */

var copyBoxElements = document.querySelectorAll('.js-copy-box');
copyBoxElements.forEach((copyBoxElement) => {
  copyBoxElement.dataset.code = copyBoxElement.innerHTML;
  copyBoxElement.addEventListener('click', () => {
    let code = copyBoxElement.dataset.code;
    let copyNote = copyBoxElement.dataset.success;
    let origNote = copyBoxElement.innerHTML;
    if (code != undefined) {
      navigator.clipboard.writeText(copyBoxElement.innerHTML);
      copyBoxElement.innerHTML = copyNote;

      if (origNote != copyNote) {
        setTimeout(() => {
          copyBoxElement.innerHTML = origNote;
        }, 2000);
      }
    }
  });
});

/* end copy Box */

/* sticky add to cart button */

(function initStickyAddToCartButton() {
  let staticAddToCartContainer = document.querySelector('.js-product-add-button-static-container');
  let stickyAddToCartContainer = document.querySelector('.js-product-add-button-sticky-container');
  if(!staticAddToCartContainer){
    return;
  }
  document.addEventListener("scroll", () => {
    checkIfViewportOverAddToCartButton(staticAddToCartContainer);
  });
})();

function checkIfViewportOverAddToCartButton(staticAddToCartContainer){
  let headerHeight = 0;
  let header = document.querySelector('.js-header-section');
  if(header){
    headerHeight = header.clientHeight;
  }
  if(staticAddToCartContainer.getBoundingClientRect().y < (headerHeight - staticAddToCartContainer.scrollHeight)){
    staticAddToCartContainer.classList.add("sticky");
  }else{
    staticAddToCartContainer.classList.remove("sticky");
  }
}

/* end sticky add to cart button */